export const environment = {
  production: true,
  projectConfiguration: {
    name: "PLUS_DIGITAL_DEMO",
    API_URL: "https://4om.api.demo.plusdigital.it/api" 
  },
  keys: {
    TinyMCE: "boqg39ohpzcc8jme5jt2focybafrja1frizyfdnt53fa7i6w"
  },
  // Configurazione Business Intelligence
  biDomain: "https://bi.plusdigital.it",
  // Configurazione Plus Digital
  brand: {
    type: 'plusdigital',
    name: 'Plus4OM',
    theme: {
      primaryColor: '#ff5050',  
      secondaryColor: '#fa8a00',
      bgColor: '#ff5050',
      logo: 'assets/images/logo/plus-om.png',
      favicon: 'favicon-4om.ico',
      loginBackground: 'assets/images/background/plus4om-bg.jpg',
      extendedLogo: 'assets/images/logo/plus-om-extended.png'
    }
  }
};